"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M23 18V18C24.1046 18 25 17.1046 25 16V4C25 2.89543 24.1046 2 23 2H3C1.89543 2 1 2.89543 1 4V16C1 17.1046 1.89543 18 3 18V18", stroke: "black", strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M11.991 13.593C12.5631 13.0729 13.4369 13.0729 14.009 13.593L20.7928 19.7601C21.4691 20.3749 21.0341 21.5 20.1201 21.5H5.87991C4.96588 21.5 4.53091 20.3749 5.20724 19.7601L11.991 13.593Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M30.3333 24V24C31.8061 24 33 22.8061 33 21.3333V5.33334C33 3.86058 31.8061 2.66667 30.3333 2.66667H3.66667C2.19391 2.66667 1 3.86058 1 5.33334V21.3333C1 22.8061 2.19391 24 3.66667 24V24", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M15.7106 18.1857C16.4417 17.5211 17.5582 17.5211 18.2892 18.1857L27.3342 26.4084C28.1796 27.177 27.6359 28.5833 26.4934 28.5833H7.50647C6.36393 28.5833 5.82022 27.177 6.66563 26.4084L15.7106 18.1857Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0)] }), void 0));
};
var PresentIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.PresentIcon = PresentIcon;
//# sourceMappingURL=PresentIcon.js.map